import themeVariables from "@Theme/exportColor.module.scss";

export default ({ rotate = 0, fill = themeVariables.primary4 }) => (
  <svg
    style={rotate ? { transform: `rotate(${rotate}deg)` } : {}}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.85156 1.14531C8.65781 0.951562 8.33906 0.951562 8.14531 1.14531L2.64531 6.64531C2.45156 6.83906 2.45156 7.15781 2.64531 7.35156C2.83906 7.54531 3.15781 7.54531 3.35156 7.35156L7.99844 2.70469V14.4984C7.99844 14.7734 8.22344 14.9984 8.49844 14.9984C8.77344 14.9984 8.99844 14.7734 8.99844 14.4984V2.70469L13.6453 7.35156C13.8391 7.54531 14.1578 7.54531 14.3516 7.35156C14.5453 7.15781 14.5453 6.83906 14.3516 6.64531L8.85156 1.14531Z"
      fill={fill}
    />
  </svg>
);
